<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-监督员-修改
    -->
    <el-dialog
    title="修改监督员"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">修改监督员</div>
      <!-- 全分类选择 -->
      <!-- <el-form-item label="选择全分类" prop="name" >
            <div>{{ form.categorya.name }}</div>
        
          <el-button @click="chooseCategory" icon="el-icon-plus">选择全分类作为监督员标题</el-button>
        </el-form-item> -->

        <el-form-item label="所属组织" prop="organization">
          <el-select v-model="form.organization" placeholder="请选择所属组织" clearable filterable style="width: 300px;">
            <el-option v-for="item in companyList" :key="item.ma_company_id" :label="item.name" :value="item.ma_company_id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="监督员身份" prop="identity">
          <el-checkbox-group v-model="form.identity">
            <el-checkbox label="1" style="margin-right: 20px;">安全监督员</el-checkbox>
            <el-checkbox label="2" style="margin-right: 20px;">质量监督员</el-checkbox>
            <el-checkbox label="3" style="margin-right: 20px;">环保监督员</el-checkbox>
            <el-checkbox label="4">消防监督员</el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="员工身份" prop="employee_identity">
          <el-select v-model="form.employee_identity" placeholder="请选择员工身份" clearable style="width: 300px;">
            <el-option label="正式员工" value="1"></el-option>
            <el-option label="临时员工" value="2"></el-option>
            <el-option label="外包员工" value="3"></el-option>
            <el-option label="实习员工" value="4"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="身份证号" prop="id_card">
          <el-input v-model="form.id_card" placeholder="请输入身份证号" class="max-w460"></el-input>
        </el-form-item>

        <el-form-item label="性别" prop="gender">
          <el-radio-group v-model="form.gender">
            <el-radio label="1">男</el-radio>
            <el-radio label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="出生日期" prop="birth_date">
          <el-date-picker
            v-model="form.birth_date"
            type="date"
            placeholder="选择出生日期"
            value-format="yyyy-MM-dd"
            style="width: 300px;">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="国籍" prop="nationality">
          <el-select v-model="form.nationality" placeholder="请选择国籍" clearable style="width: 300px;">
            <el-option label="中国" value="1"></el-option>
            <el-option label="中国香港特别行政区" value="2"></el-option>
            <el-option label="中国台湾" value="3"></el-option>
            <el-option label="中国澳门特别行政区" value="4"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="民族" prop="ethnicity">
          <el-select v-model="form.ethnicity" placeholder="请选择民族" clearable filterable style="width: 300px;">
            <el-option label="汉族" value="1"></el-option>
            <el-option label="蒙古族" value="2"></el-option>
            <el-option label="回族" value="3"></el-option>
            <el-option label="藏族" value="4"></el-option>
            <el-option label="维吾尔族" value="5"></el-option>
            <el-option label="苗族" value="6"></el-option>
            <el-option label="彝族" value="7"></el-option>
            <el-option label="壮族" value="8"></el-option>
            <el-option label="布依族" value="9"></el-option>
            <el-option label="朝鲜族" value="10"></el-option>
            <el-option label="满族" value="11"></el-option>
            <el-option label="侗族" value="12"></el-option>
            <el-option label="瑶族" value="13"></el-option>
            <el-option label="白族" value="14"></el-option>
            <el-option label="土家族" value="15"></el-option>
            <el-option label="哈尼族" value="16"></el-option>
            <el-option label="哈萨克族" value="17"></el-option>
            <el-option label="傣族" value="18"></el-option>
            <el-option label="黎族" value="19"></el-option>
            <el-option label="傈僳族" value="20"></el-option>
            <el-option label="佤族" value="21"></el-option>
            <el-option label="畲族" value="22"></el-option>
            <el-option label="高山族" value="23"></el-option>
            <el-option label="拉祜族" value="24"></el-option>
            <el-option label="水族" value="25"></el-option>
            <el-option label="东乡族" value="26"></el-option>
            <el-option label="纳西族" value="27"></el-option>
            <el-option label="景颇族" value="28"></el-option>
            <el-option label="柯尔克孜族" value="29"></el-option>
            <el-option label="土族" value="30"></el-option>
            <el-option label="达斡尔族" value="31"></el-option>
            <el-option label="仫佬族" value="32"></el-option>
            <el-option label="羌族" value="33"></el-option>
            <el-option label="布朗族" value="34"></el-option>
            <el-option label="撒拉族" value="35"></el-option>
            <el-option label="毛南族" value="36"></el-option>
            <el-option label="仡佬族" value="37"></el-option>
            <el-option label="锡伯族" value="38"></el-option>
            <el-option label="阿昌族" value="39"></el-option>
            <el-option label="普米族" value="40"></el-option>
            <el-option label="塔吉克族" value="41"></el-option>
            <el-option label="怒族" value="42"></el-option>
            <el-option label="乌孜别克族" value="43"></el-option>
            <el-option label="俄罗斯族" value="44"></el-option>
            <el-option label="鄂温克族" value="45"></el-option>
            <el-option label="德昂族" value="46"></el-option>
            <el-option label="保安族" value="47"></el-option>
            <el-option label="裕固族" value="48"></el-option>
            <el-option label="京族" value="49"></el-option>
            <el-option label="塔塔尔族" value="50"></el-option>
            <el-option label="独龙族" value="51"></el-option>
            <el-option label="鄂伦春族" value="52"></el-option>
            <el-option label="赫哲族" value="53"></el-option>
            <el-option label="门巴族" value="54"></el-option>
            <el-option label="珞巴族" value="55"></el-option>
            <el-option label="基诺族" value="56"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="学历" prop="education">
          <el-radio-group v-model="form.education">
            <el-radio label="1">小学</el-radio>
            <el-radio label="2">初中</el-radio>
            <el-radio label="3">高中</el-radio>
            <el-radio label="4">大专</el-radio>
            <el-radio label="5">本科</el-radio>
            <el-radio label="6">硕士</el-radio>
            <el-radio label="7">博士</el-radio>
            <el-radio label="8">其他</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="姓名" prop="name"><el-input v-model="form.name" placeholder="请输入姓名" class="max-w460"></el-input></el-form-item>

        <el-form-item label="账号" prop="phone">
            <el-checkbox v-model="form.auto_generate_account">自动生成账号</el-checkbox>
            <div style="color: #909399; font-size: 12px; margin-top: 5px;">帐号是您可以登录系统的凭证, 可以使用英文(大小写), 数字, 特殊字符(_-)的组合, 如不填写系统会自动生成.帐号可以在用户信息中修改</div>
            <el-input v-if="!form.auto_generate_account" v-model="form.phone" placeholder="请输入账号" class="max-w460" style="margin-top: 10px;"></el-input>
          </el-form-item>

          <el-form-item label="密码" prop="password">
            <el-checkbox v-model="form.use_default_password">默认密码</el-checkbox>
            <div style="color: #909399; font-size: 12px; margin-top: 5px;">如果您输入的账号在系统内已存在勾选默认密码将不会更改原密码</div>
            <el-input v-if="!form.use_default_password" v-model="form.password" type="password" placeholder="请输入密码" class="max-w460" show-password style="margin-top: 10px;"></el-input>
          </el-form-item>

          <el-form-item label="手机号码" prop="mobile">
            <el-input v-model="form.mobile" placeholder="请输入手机号码" class="max-w460"></el-input>
          </el-form-item>

          <el-form-item label="牌照号" prop="license_number">
            <el-input v-model="form.license_number" placeholder="请输入牌照号" class="max-w460"></el-input>
          </el-form-item>

          <el-form-item label="适用岗位" prop="applicable_position">
            <el-input v-model="form.applicable_position" placeholder="请输入适用岗位" class="max-w460"></el-input>
          </el-form-item>

          <el-form-item label="职位" prop="position">
            <el-input v-model="form.position" placeholder="请输入职位" class="max-w460"></el-input>
          </el-form-item>

          <el-form-item label="部门" prop="department">
            <el-input v-model="form.department" placeholder="请输入部门" class="max-w460"></el-input>
          </el-form-item>

          <el-form-item label="注册照" prop="registration_photo">
            <div class="img-list">
              <div v-if="form.registration_photo" class="item">
                <img :src="form.registration_photo" width="100" height="100" />
                <div class="hide-btn" @click="deleteRegistrationPhoto"><i class="el-icon-close"></i></div>
              </div>
              <div v-else class="item upload-btn" @click="openUpload('registration_photo')">
                <i class="el-icon-plus"></i>
              </div>
            </div>
          </el-form-item>

          <el-form-item label="备注" prop="remark">
            <el-input type="textarea" v-model="form.remark" :rows="3" placeholder="请输入备注" class="max-w460"></el-input>
          </el-form-item>

          <div class="common-form">联系方式</div>

          <el-form-item label="QQ" prop="qq">
            <el-input v-model="form.qq" placeholder="请输入QQ" class="max-w460"></el-input>
          </el-form-item>

          <el-form-item label="微信" prop="wechat">
            <el-input v-model="form.wechat" placeholder="请输入微信" class="max-w460"></el-input>
          </el-form-item>

          <el-form-item label="邮箱" prop="email">
            <el-input v-model="form.email" placeholder="请输入邮箱" class="max-w460"></el-input>
          </el-form-item>

          <el-form-item label="所属地区" prop="region">
            <div style="display: flex;">
              <el-select @change="provinceChange" v-model="form.province_name" filterable placeholder="请选择省份" style="width: 140px; margin-right: 10px;">
                <el-option v-for="item in province_options" :key="item.id" :label="item.name" :value="item"></el-option>
              </el-select>
              <el-select @change="cityChange" v-model="form.city_name" filterable placeholder="请选择城市" :disabled="lock_city" style="width: 140px; margin-right: 10px;">
                <el-option v-for="item in city_options" :key="item.id" :label="item.name" :value="item"></el-option>
              </el-select>
              <el-select @change="regionChange" v-model="form.region_name" filterable placeholder="请选择区域" :disabled="lock_region" style="width: 140px;">
                <el-option v-for="item in region_options" :key="item.id" :label="item.name" :value="item"></el-option>
              </el-select>
            </div>
          </el-form-item>

          <el-form-item label="详细地址" prop="address">
            <el-input type="textarea" v-model="form.address" :rows="2" placeholder="请输入详细地址" class="max-w460"></el-input>
          </el-form-item>

          <div class="common-form">工作信息</div>

          <el-form-item label="付费类型" prop="payment_type">
            <el-radio-group v-model="form.payment_type">
              <el-radio label="1">企业开通</el-radio>
            </el-radio-group>
            <div style="color: #909399; font-size: 12px; margin-top: 5px;">是应该由谁来付费，企业开通:则默认由企业开通，个人开通:则优先个人开通</div>
          </el-form-item>

          <el-form-item label="线路" prop="route">
            <el-input v-model="form.route" placeholder="请输入线路" class="max-w460"></el-input>
            <div style="color: #909399; font-size: 12px; margin-top: 5px;">公交车线路班次</div>
          </el-form-item>

          <div v-if="form.identity.includes('1')">
          <el-form-item label="安全监督内容">
            <div style="width: 500px; line-height: 1.6;">负责安全监督相关工作，包括安全检查、隐患排查、安全培训等。</div>
          </el-form-item>
        </div>

        <div v-if="form.identity.includes('2')">
          <el-form-item label="质量监督内容">
            <div style="width: 500px; line-height: 1.6;">负责质量监督相关工作，包括质量检查、质量验收、质量改进等。</div>
          </el-form-item>
        </div>

        <div v-if="form.identity.includes('3')">
          <el-form-item label="环保监督内容">
            <div style="width: 500px; line-height: 1.6;">负责环保监督相关工作，包括环保检查、环保监测、环保整改等。</div>
          </el-form-item>
        </div>

        <div v-if="form.identity.includes('4')">
          <el-form-item label="消防监督内容">
            <div style="width: 500px; line-height: 1.6;">负责消防监督相关工作，包括消防检查、消防演练、消防设施维护等。</div>
          </el-form-item>
        </div>
       
    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>

  <!--上传图片组件-->
  <Upload v-if="isupload" :isupload="isupload" :type="'product'" @returnImgs="returnImgsFunc"></Upload>
</el-dialog>
  
</template>

<script>
import Ma_supervisorApi from '@/api/ma_supervisor.js';
import Ma_companyApi from '@/api/ma_company.js';
import Upload from '@/components/file/Upload';
import UserApi from '@/api/user.js';

export default {
  components: {
    Upload
  },
  data() {
    return {
        /*form表单数据*/
        form: {
          name: '',
          code: 'custom',
          id_card: '',
          gender: '',
          birth_date: '',
          nationality: '',
          ethnicity: '',
          education: '',
          phone: '',
          password: '',
          auto_generate_account: false,
          use_default_password: false,
          mobile: '',
          license_number: '',
          applicable_position: '',
          position: '',
          department: '',
          registration_photo: '',
          remark: '',
          employee_identity: '',
          organization: '',
          identity: [],
          qq: '',
          wechat: '',
          email: '',
          province_name: '',
          city_name: '',
          region_name: '',
          province_id: 0,
          city_id: 0,
          region_id: 0,
          address: '',
          payment_type: '',
          route: '',
          sort: 50,
        },
        loading: false,
        /*验证规则*/
        rules: {
          name: [{ required: true, message: '请输入监督员名称', trigger: 'blur' }],
        },
        dialogVisible: false,
        /*组织列表*/
        companyList: [],
        /*上传图片*/
        isupload: false,
        currentUploadField: '',
        /*城市锁*/
        lock_city: true,
        /*区域锁*/
        lock_region: true,
        province_options: {},
        city_options: {},
        region_options: {},
      };
  },
  created() {
    this.dialogVisible = this.open_add;
    this.getCompanyList();
    this.getDetail();
    this.getAddressList();
  },
  props: ["open_add","ma_supervisor_id"],
  methods: {
    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc(){
      this.dialogFormVisible("error")
    },

    /*获取组织列表*/
    getCompanyList() {
      let self = this;
      Ma_companyApi.list({}, true)
        .then(data => {
          self.companyList = data.data.list.data;
        })
        .catch(error => {});
    },

    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      Ma_supervisorApi.detail({ma_supervisor_id: self.ma_supervisor_id},true).then(res => {
          self.form = res.data;
          if (!self.form.identity) {
            self.form.identity = [];
          } else {
            if (typeof self.form.identity === 'string') {
              self.form.identity = self.form.identity.split(',');
            }
          }
          if (!self.form.id_card) {
            self.form.id_card = '';
          }
          if (!self.form.gender) {
            self.form.gender = '';
          }
          if (!self.form.birth_date) {
            self.form.birth_date = '';
          }
          if (!self.form.nationality) {
            self.form.nationality = '';
          }
          if (!self.form.ethnicity) {
            self.form.ethnicity = '';
          }
          if (!self.form.education) {
            self.form.education = '';
          }
          if (!self.form.phone) {
            self.form.phone = '';
          }
          if (!self.form.password) {
            self.form.password = '';
          }
          self.form.auto_generate_account = self.form.auto_generate_account === 1 || self.form.auto_generate_account === true;
          self.form.use_default_password = self.form.use_default_password === 1 || self.form.use_default_password === true;
          if (!self.form.mobile) {
            self.form.mobile = '';
          }
          if (!self.form.license_number) {
            self.form.license_number = '';
          }
          if (!self.form.applicable_position) {
            self.form.applicable_position = '';
          }
          if (!self.form.department) {
            self.form.department = '';
          }
          if (!self.form.registration_photo) {
            self.form.registration_photo = '';
          }
          if (!self.form.remark) {
            self.form.remark = '';
          }
          if (!self.form.position) {
            self.form.position = '';
          }
          if (!self.form.employee_identity) {
            self.form.employee_identity = '';
          }
          if (!self.form.payment_type) {
            self.form.payment_type = '';
          }
          if (!self.form.route) {
            self.form.route = '';
          }
          if (!self.form.qq) {
            self.form.qq = '';
          }
          if (!self.form.wechat) {
            self.form.wechat = '';
          }
          if (!self.form.email) {
            self.form.email = '';
          }
          if (!self.form.province_name) {
            self.form.province_name = '';
          }
          if (!self.form.city_name) {
            self.form.city_name = '';
          }
          if (!self.form.region_name) {
            self.form.region_name = '';
          }
          if (!self.form.province_id) {
            self.form.province_id = 0;
          }
          if (!self.form.city_id) {
            self.form.city_id = 0;
          }
          if (!self.form.region_id) {
            self.form.region_id = 0;
          }
          if (!self.form.address) {
            self.form.address = '';
          }
          if (self.form.province_id > 0) {
            self.lock_city = false;
            self.cityList(self.form.province_id);
          }
          if (self.form.city_id > 0) {
            self.lock_region = false;
            self.regionList(self.form.city_id);
          }
          self.loading = false;
        })
        .catch(error => {});
    },
    onSubmit() {
      let self = this;
      let form = self.form;
      form.ma_supervisor_id = self.ma_supervisor_id;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Ma_supervisorApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消修改，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },

    /*打开上传图片*/
    openUpload(field) {
      this.currentUploadField = field;
      this.isupload = true;
    },

    /*上传图片回调*/
    returnImgsFunc(e) {
      if (e != null) {
        if (this.currentUploadField === 'registration_photo') {
          let filePath = e[0].file_path;
          this.form.registration_photo = filePath;
          this.$set(this.form, 'registration_photo', filePath);
        }
      }
      this.isupload = false;
    },

    /*删除注册照*/
    deleteRegistrationPhoto() {
      this.form.registration_photo = '';
    },

    /*省份获取*/
    getAddressList() {
      let self = this;
      UserApi.provinceList('', true)
        .then(data => {
          self.province_options = data.data.list;
        })
        .catch(error => {});
    },

    /*市列表*/
    cityList(id) {
      let self = this;
      let Params = {};
      Params.province_id = id;
      UserApi.city_list(Params, true)
        .then(data => {
          self.city_options = data.data.list;
        })
        .catch(error => {});
    },

    /*区列表*/
    regionList(id) {
      let self = this;
      let Params = {};
      Params.region_id = id;
      UserApi.region_list(Params, true)
        .then(data => {
          self.region_options = data.data.list;
        })
        .catch(error => {});
    },

    /*选择省*/
    provinceChange(e) {
      let self = this;
      self.form.province_id = e.id;
      self.form.province_name = e.name;
      self.form.city_id = 0;
      self.form.city_name = '';
      self.form.region_id = 0;
      self.form.region_name = '';
      self.lock_city = false;
      self.lock_region = true;
      self.cityList(e.id);
    },

    /*选择市*/
    cityChange(e) {
      let self = this;
      self.form.city_id = e.id;
      self.form.city_name = e.name;
      self.form.region_id = 0;
      self.form.region_name = '';
      self.lock_region = false;
      self.regionList(e.id);
    },

    /*选择区*/
    regionChange(e) {
      let self = this;
      self.form.region_id = e.id;
      self.form.region_name = e.name;
    },
  }
}
</script>

<style>
.img-list {
  display: flex;
  align-items: center;
}

.img-list .item {
  position: relative;
  width: 100px;
  height: 100px;
  margin-right: 10px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow: hidden;
}

.img-list .item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.img-list .item .hide-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 20px;
  height: 20px;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.img-list .item.upload-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
  cursor: pointer;
}

.img-list .item.upload-btn:hover {
  background: #e6e8eb;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/ma_supervisor/index/part/edit.vue